import * as React from 'react';
import { useRecoilState } from 'recoil';
import { useUser } from '../atoms';
import { contextDialogAtom } from '../atoms/dialogContext';
import EditPreferito from '../components/EditPreferito';
import { ConfirmDialogService } from './ConfirmDialog';
import ContextSelectorDialog from './ContextSelectorDialog';

function ModalContainer() {
    const [contextDialog, setOpenDialog] = useRecoilState(contextDialogAtom)

    const [keyId, setKeyId] = React.useState(0)

    const user = useUser()
    const handleCloseDialog = () => {
        setOpenDialog({ show: false })
        setKeyId(k => k + 1)
    }
    const isNotAzienda = user?.role !== 'azienda'

    return (
        <>
            {isNotAzienda &&
                <ContextSelectorDialog key={keyId}
                    open={contextDialog.show}
                    preferito={contextDialog.preferito}
                    onSetContextPreferito={contextDialog.onSetContextPreferito}
                    onClose={handleCloseDialog}
                    user={user}
                />
            }
            <EditPreferito />
            <ConfirmDialogService />
        </>
    );
}

export default ModalContainer
